import {
    AUTHENTICATE_ZOHO_REQUEST, AUTHTENTICATING_ZOHO_SUCCEEDED, AUTHTENTICATING_ZOHO_FAILED,
    UPDATE_ZOHO_REQUEST, UPDATING_ZOHO_SUCCEEDED, UPDATING_ZOHO_FAILED,
  } from 'constants/actionTypes';
  
  const initialState = {
    changes: {
      saving: false,
      updating: false,
      error: null
    }
  };
  
  function zohoReducer(state = initialState, action) {
    switch (action.type) {
  
      case AUTHENTICATE_ZOHO_REQUEST: {
        return {
          ...state,
          changes: {
            ...state.changes,
            saving: true,
            error: null
          }
        }
      }
  
      case AUTHTENTICATING_ZOHO_SUCCEEDED: {
        return {
          ...state,
          changes: {
            ...state.changes,
            saving: false,
            error: null
          }
        }
      }
  
      case AUTHTENTICATING_ZOHO_FAILED: {
        return {
          ...state,
          changes: {
            ...state.changes,
            saving: false,
            error: action.payload
          }
        }
      }
  
      case UPDATE_ZOHO_REQUEST: {
        return {
          ...state,
          changes: {
            ...state.changes,
            updating: true,
            error: null
          }
        }
      }
  
      case UPDATING_ZOHO_SUCCEEDED: {
        return {
          ...state,
          changes: {
            ...state.changes,
            updating: false,
            error: null
          }
        }
      }
  
      case UPDATING_ZOHO_FAILED: {
        return {
          ...state,
          changes: {
            ...state.changes,
            updating: false,
            error: action.payload
          }
        }
      }

      default:
        return state;
    }
  }
  
  export { zohoReducer };